import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class RechargeDireService {

  /**
   *
   * @type {BehaviorSubject<boolean>}
   */
  private rechargeClientSource = new BehaviorSubject<boolean>(false);

  /**
   *
   * @type {BehaviorSubject<boolean>}
   */
  private rechargeInvoiceSource = new BehaviorSubject<boolean>(false);

  /**
   *
   * @type {Observable<boolean>}
   */
  rechargeClient$ = this.rechargeClientSource.asObservable();

  /**
   *
   * @type {Observable<boolean>}
   */
  rechargeInvoice$ = this.rechargeInvoiceSource.asObservable();

  constructor()
  { }

  /**
   *
   * @param {boolean} hide
   */
  setRechargeFromClient(hide: boolean) {
      this.rechargeClientSource.next(hide);
  }

  /**
   *
   * @param {boolean} hide
   */
  setRechargeFromInvoice(hide: boolean) {
      this.rechargeInvoiceSource.next(hide);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/recharge-dire.service.ts